'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var inputTranslator = {
    addRightInput: function addRightInput(field, updatedObject) {
        // this weird code is for tricking Chrome ignoring of autocomplete="off", because it causing issues all the times 
        // for example it overlaps Smartform options listed underneath input... So kick that bitch to the ass.
        var rightInputName = inputTranslator.translateAlternativeInputName(field);
        if (rightInputName) updatedObject[rightInputName] = updatedObject[field];
    },
    translateAlternativeInputName: function translateAlternativeInputName(field) {
        switch (field) {
            case 'amountOfSquirrels':
                return 'street';
            case 'guardsOfOrange':
                return 'postCode';
            case 'jediPrayer':
                return 'city';
            case 'gooseFederation':
                return 'firstName';
            case 'hamsterPolice':
                return 'lastName';
            case 'hansVonZigtenstern':
                return 'name';
            case 'whiteAsphalt':
                return 'companyName';
            case 'rocksEvolution':
                return 'contactPerson';
            default:
                return null;
        }
    },

    addCipheredTwin: function addCipheredTwin(field, updatedObject) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = (0, _getIterator3.default)(this.cipherCouples), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var couple = _step.value;

                if (field === couple[0]) {
                    updatedObject[couple[0]] = updatedObject[couple[1]];
                    break;
                }
                if (field === couple[1]) {
                    updatedObject[couple[1]] = updatedObject[couple[0]];
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    },
    cipherCouples: [['amountOfSquirrels', 'street'], ['guardsOfOrange', 'postCode'], ['jediPrayer', 'city'], ['gooseFederation', 'firstName'], ['hamsterPolice', 'lastName'], ['hansVonZigtenstern', 'name'], ['whiteAsphalt', 'companyName'], ['rocksEvolution', 'contactPerson']]
};

exports.default = inputTranslator;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/inputTranslator.js
// module id = 407
// module chunks = 0 2